<template>
  <matrix-form :rows="issue.rows" :columns="issue.items" column-key="id" :show-col-text="false">
    <template v-slot:content="{ row }">
      <div v-for="(col, index) of issue.items" :key="col.id" class="mb-2 last:mb-0">
        <div class="my-1 rich-text-wrap" v-html="col.content.richText"></div>
        <fill
          :option="issue.getCellByRowAndCol(row, col)"
          :question-type="question.questionType"
          :question-id="question.id"
          :enable-relation="issue.setting.enableRelation"
          :disable-copy="issue.disableCopy"
          :question="question"
        />
      </div>
    </template>
  </matrix-form>
</template>

<script>
import MatrixForm from '@/questions/components/MatrixForm'
import Fill from '@/questions/components/Fill'
import TextFill from '@/questions/text-fill/TextFill'

export default {
  name: 'MatrixFill',
  components: { TextFill, Fill, MatrixForm },
  changeExpr: 'changeExpr',
  computed: {
    changeExpr() {
      return this.issue.cells
        .map(i => i.value)
        .filter(Boolean)
        .join('-')
    }
  }
}
</script>

<style scoped></style>
